import clsx from "clsx";
import st from "@/styles/Home.module.scss";
import ClickableBgOverlay from "@/ui/ClickableBgOverlay.tsx";
import HomeDashboardCalculator from "@/components/HomeDashboardCalculator.tsx";
import {useEffect, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {useLocation} from "react-router-dom";
import useCalc from "@/hooks/calculator.ts";


const MobileCalculator = () => {
    const [openCalculator, setOpenCalculator] = useState<boolean>(false)
    const location = useLocation()
    const calc = useCalc()
    
    const openCalculatorHandler = (x:boolean) => {
        calc.update_calculator_limits()
        setOpenCalculator(x)
    }
    
    useEffect(() => {
        
        eventEmitter.on(CommonClass.ModalEvents.OpenCalculator, openCalculatorHandler)
        
        return() => {
            eventEmitter.off(CommonClass.ModalEvents.OpenCalculator, openCalculatorHandler)
        }
        
    }, []);
    
    useEffect(() => {
        setOpenCalculator(false)
    }, [location]);
    
    useEffect(() => {
        
        if(openCalculator) {
            const root =  document.getElementsByTagName('html')[0];
            root.setAttribute('style', 'overflow-y: hidden');
        } else {
            const root =  document.getElementsByTagName('html')[0];
            root.removeAttribute('style');
        }
        
        
        return () => {
            const root =  document.getElementsByTagName('html')[0];
            root.removeAttribute('style');
        }
    }, [openCalculator])
    
    return openCalculator && (
        <>
            <div
                className={clsx(st.overlay)}
                onClick={(e) => {
                    e.stopPropagation()
                    setOpenCalculator(false)
                }}
            />
            
            <ClickableBgOverlay
                onClick={(e) => {
                    e.stopPropagation()
                    setOpenCalculator(false)
                }}
            />
            
            <div className={st.mobile_calculator}>
                <HomeDashboardCalculator
                    onClose={() => {
                        setOpenCalculator(false)
                    }}
                />
            </div>
        </>
    )
}

export default MobileCalculator